import { useAppSelector } from '../..'
import { type StudentDistribution } from '../../../models/Distribution'
import { type ISurveyTemplate } from '../../../models/SurveyTemplate'

export const getStudentDistributionsList = (): StudentDistribution[] | null => useAppSelector((state) => state.studentDistributions.studentDistributions)
export const isStudentDistributionsLoading = (): boolean => useAppSelector((state) => state.studentDistributions.isStudentDistributionsLoading)
export const isStudentDistributionsHavingError = (): string | null => useAppSelector((state) => state.studentDistributions.error)
export const getStudentSelectedSurvey = (): ISurveyTemplate | null => useAppSelector((state) => state.studentDistributions.studentSelectedSurvey)
export const getIsLoading = (): boolean => useAppSelector((state) => state.studentDistributions.isLoading)
